"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasUnsupportedAddressConditions = void 0;

var lodash_1 = require("lodash");

var hasUnsupportedAddressConditions = function hasUnsupportedAddressConditions(addresses) {
  var _a, _b, _c; // Get Current State
  // TODO: addresses.find(a => a.primary) ??? instead of grabbing most recent start date


  var currentState = (_c = (_b = (_a = (0, lodash_1.orderBy)(addresses, ["startedAt"], ["desc"])) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.state) !== null && _c !== void 0 ? _c : ""; // TODO: no ?? ""
  // DQ
  // --- Current residency DQ's (TODO: UNSUPPORTED_STATES)

  if (["AL", "NC", "VA", "MD"].includes(currentState)) return true;
  return false;
};

exports.hasUnsupportedAddressConditions = hasUnsupportedAddressConditions;